<!-- views/admin/children/Review.vue -->
<template>
  <div class="review-config">
    <!-- 头部操作栏 -->
    <div class="header">
      <h1>往届回顾配置</h1>
      <div class="header-actions">
        <button class="btn save-btn" @click="saveConfig" :disabled="isSaving">
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>

    <!-- 配置编辑区域 -->
    <div class="config-editor">
      <!-- 板块基础信息 -->
      <div class="config-section">
        <div class="section-header">
          <h2>板块基础信息</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>板块标题</label>
            <input type="text" v-model="sectionData.title" placeholder="请输入板块标题">
          </div>
          <div class="form-group">
            <label>板块描述</label>
            <textarea v-model="sectionData.desc" placeholder="请输入板块描述"></textarea>
          </div>
        </div>
      </div>

      <!-- 照片配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>照片配置</h2>
        </div>
        <div class="section-content">
          <div class="photos-container">
            <div
                v-for="(photo, index) in sectionData.data.photos"
                :key="index"
                class="photo-item"
            >
              <div class="photo-preview">
                <img :src="photo.url" :alt="photo.desc" class="preview-img" />
                <button class="remove-photo-btn" @click="removePhoto(index)">×</button>
              </div>
              <div class="form-group">
                <label>照片描述</label>
                <input type="text" v-model="photo.desc" placeholder="请输入照片描述">
              </div>
              <div class="form-group">
                <label>照片链接</label>
                <input type="text" v-model="photo.url" placeholder="请输入照片链接">
              </div>
              <div class="form-group">
                <label>上传照片</label>
                <input
                    type="file"
                    @change="uploadPhoto($event, index)"
                    accept="image/*"
                    hidden
                    :ref="el => photoUploadRefs[index] = el"
                />
                <button
                    class="upload-btn"
                    @click="photoUploadRefs[index]?.click()"
                >
                  选择图片上传
                </button>
              </div>
            </div>

            <!-- 添加照片按钮 -->
            <div class="add-photo-container">
              <button class="add-photo-btn" @click="addPhoto">添加照片</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getBanner, updateBannerApi,uploadFileApi } from '@/api/website'

// 板块数据
const sectionData = ref({
  id: "review",
  title: "",
  desc: "",
  component: "ReviewGallery",
  data: {
    photos: []
  }
})

const isSaving = ref(false)
const allConfig = ref({}) // 保存完整的配置数据

// 加载配置
const loadConfig = async () => {
  try {
    const response = await getBanner({"adminId":1})
    if (response.data) {
      allConfig.value = response.data.data

      // 查找review板块数据
      const reviewSection = allConfig.value.data.sections.find(section => section.id === "review")
      if (reviewSection) {
        sectionData.value = {
          ...sectionData.value,
          ...reviewSection
        }
      }
    }
  } catch (error) {
    console.error('加载配置失败:', error)
    alert('加载配置失败，请重试')
  }
}

// 保存配置
const saveConfig = async () => {
  try {
    isSaving.value = true

    // 更新完整配置中的review板块数据
    const sectionIndex = allConfig.value.data.sections.findIndex(section => section.id === "review")
    if (sectionIndex !== -1) {
      allConfig.value.data.sections[sectionIndex] = {...sectionData.value}
    }
    // 查找并更新导航栏中指向#intro的链接标题
    const navSection = allConfig.value.data.sections.find(section => section.id === "nav")
    if (navSection) {
      const introNavItem = navSection.data.find(item => item.link === "#review")
      if (introNavItem) {
        introNavItem.label = sectionData.value.title
      }
    }
    await updateBannerApi(allConfig.value)
    alert('保存成功！')
  } catch (error) {
    console.error('保存配置失败:', error)
    alert('保存失败，请重试')
  } finally {
    isSaving.value = false
  }
}

// 添加照片
const addPhoto = () => {
  sectionData.value.data.photos.push({
    url: "",
    desc: ""
  })
}

// 删除照片
const removePhoto = (index) => {
  if (confirm('确定要删除这张照片吗？')) {
    sectionData.value.data.photos.splice(index, 1)
  }
}

// 添加上传相关的 refs
const photoUploadRefs = ref([])

// 添加上传方法
const uploadPhoto = async (event, index) => {
  const file = event.target.files[0]
  if (!file) return

  try {
    const formData = new FormData()
    formData.append('multipartFile', file)

    const response = await uploadFileApi(formData)
    if (response.data && response.data.data) {
      // 更新对应照片的 URL
      sectionData.value.data.photos[index].url = response.data.data
    }
  } catch (error) {
    console.error('上传图片失败:', error)
    alert('上传失败，请重试')
  }
}
// 初始化加载配置
onMounted(() => {
  loadConfig()
})
</script>

<style scoped lang="scss">
.review-config {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.header {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;

  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .save-btn {
    background-color: #E6398B;
    color: white;

    &:hover:not(:disabled) {
      background-color: #d4287a;
    }
  }
}

.config-editor {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.config-section {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  background-color: #fafafa;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  input[type="text"],
  input[type="color"],
  select,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
}

.photos-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.photo-item {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 16px;
  position: relative;
}

.photo-preview {
  position: relative;
  margin-bottom: 16px;

  .preview-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .remove-photo-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ff4d4f;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: #d9363e;
    }
  }
}

.add-photo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1 / -1;

  .add-photo-btn {
    padding: 12px 24px;
    background-color: #f5f5f5;
    border: 1px dashed #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    transition: all 0.3s;

    &:hover {
      background-color: #e8e8e8;
      border-color: #1890ff;
      color: #1890ff;
    }
  }
}
.upload-btn {
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #40a9ff;
  }
}

</style>
